import { gql, TypedDocumentNode } from "@apollo/client";

import { AwsIntegration, QueryAttachableAwsIntegrationsInSpaceArgs } from "types/generated";

export const GET_ATTACHABLE_AWS_INTEGRATIONS_FOR_INTENT_PROJECT: TypedDocumentNode<
  { attachableAwsIntegrationsInSpace: AwsIntegration[] },
  QueryAttachableAwsIntegrationsInSpaceArgs
> = gql`
  query GetAttachableAwsIntegrationsForIntentProject($id: ID!) {
    attachableAwsIntegrationsInSpace(id: $id) {
      id
      name
      labels
      legacy
      spaceDetails {
        id
        name
      }
    }
  }
`;
